import { render, staticRenderFns } from "./serviceInfo.vue?vue&type=template&id=55f23eed&scoped=true"
var script = {}
import style0 from "./serviceInfo.vue?vue&type=style&index=0&id=55f23eed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f23eed",
  null
  
)

export default component.exports